<template>
  <div class="inspection-page">
    <div class="left-form" ref="madeForm">
      <avue-form ref="avueFormRef" :option="formOption" v-model="form" />
    </div>
  </div>
</template>

<script>
import { getTitleList } from '../../api'

/** 仅主表字段写入表单，避免把子表一并塞进 v-model 后随 echoData 重复提交 */
const MAIN_PLAN_FIELDS = [
  'id',
  'planName',
  'planCode',
  'planType',
  'parentTagId',
  'childTagId',
  'planDescription',
  'planAttachment',
  'issueTime',
  'revisionTime',
  'planVersion',
  'planStatus',
  'createTime',
  'updateTime',
  'createName',
  'updateName'
]

export default {
  props: {
    infoMore: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      titleList: [],
      form: {},
      formOption: {
        menu: false,
        span: 12,
        edit: true,
        column: [
          {
            label: '预案名称',
            prop: 'planName',
            type: 'input',
            maxlength: 100,
            placeholder: '请输入预案名称',
            rules: [{ required: true, message: '请输入预案名称', trigger: 'blur' }]
          },
          {
            label: '预案编号',
            prop: 'planCode',
            type: 'input',
            maxlength: 50,
            placeholder: '保存时可自动生成或手填'
          },
          {
            label: '预案类型',
            prop: 'planType',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=yj-pla-type',
            props: {
              label: 'dictValue',
              value: 'dictKey'
            },
            dataType: 'number',
            placeholder: '请选择预案类型',
            rules: [{ required: true, message: '请选择预案类型', trigger: 'change' }]
          },
          {
            label: '预案标签（父）',
            prop: 'parentTagId',
            type: 'select',
            dicData: [],
            props: { label: 'label', value: 'value' },
            dataType: 'number',
            placeholder: '请选择',
            change: () => {
              this.form.childTagId = undefined
              const childCol = this.formOption.column.find(c => c.prop === 'childTagId')
              if (childCol) {
                childCol.dicData = this.tagChildOptions(this.form.parentTagId)
              }
            }
          },
          {
            label: '预案标签（子）',
            prop: 'childTagId',
            type: 'select',
            dicData: [],
            props: { label: 'label', value: 'value' },
            dataType: 'number',
            placeholder: '请选择'
          },
          {
            label: '预案描述',
            prop: 'planDescription',
            type: 'textarea',
            maxlength: 500,
            rows: 4,
            span: 24,
            placeholder: '适用范围、编制依据、应急原则等'
          },
          {
            label: '预案附件',
            prop: 'planAttachment',
            type: 'upload',
            loadText: '附件上传中，请稍等',
            span: 24,
            propsHttp: {
              res: 'data'
            },
            tip: '请上传标准格式文件',
            action: '/api/blade-resource/oss/endpoint/put-file-attach'
          },
          {
            label: '印发时间',
            prop: 'issueTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            placeholder: '请选择印发时间'
          },
          {
            label: '修订时间',
            prop: 'revisionTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            placeholder: '请选择修订时间'
          }
        ]
      }
    }
  },
  watch: {
    infoMore: {
      handler (val) {
        this.applyDetail(val)
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.loadTags()
  },
  methods: {
    loadTags () {
      getTitleList({
        page: 1,
        size: 1000
      }).then(res => {
        if (res.data && res.data.data && res.data.data.records) {
          this.titleList = res.data.data.records
          this.refreshTagDic()
        }
      })
    },
    tagTopOptions () {
      return this.titleList
        .filter(item => item.parentId === 0 || item.parentId === '0' || item.parentId == null)
        .map(item => ({
          label: item.name,
          value: Number(item.id),
          raw: item
        }))
    },
    tagChildOptions (parentId) {
      if (parentId == null || parentId === '') return []
      const pid = Number(parentId)
      return this.titleList
        .filter(item => Number(item.parentId) === pid && Number(item.parentId) !== 0)
        .map(item => ({
          label: item.name,
          value: Number(item.id),
          raw: item
        }))
    },
    refreshTagDic () {
      const parentCol = this.formOption.column.find(c => c.prop === 'parentTagId')
      const childCol = this.formOption.column.find(c => c.prop === 'childTagId')
      if (parentCol) {
        parentCol.dicData = this.tagTopOptions()
      }
      if (childCol) {
        childCol.dicData = this.tagChildOptions(this.form.parentTagId)
      }
    },
    isEmptyPlanAttachmentText (value) {
      const text = String(value).trim()
      return !text || /^\[\s*\]$/.test(text)
    },
    normalizePlanAttachment (value) {
      if (value === undefined) return undefined
      if (value === null) return ''
      if (typeof value === 'string') {
        const text = value.trim()
        return this.isEmptyPlanAttachmentText(text) ? '' : text
      }
      if (Array.isArray(value)) {
        const attachments = value.filter(item => {
          if (item === undefined || item === null) return false
          if (typeof item === 'string') return !this.isEmptyPlanAttachmentText(item)
          return true
        })
        return attachments.length ? attachments : ''
      }
      return value
    },
    applyDetail (val) {
      if (!val || typeof val !== 'object') {
        this.form = {}
        return
      }
      const form = {}
      MAIN_PLAN_FIELDS.forEach(k => {
        if (val[k] !== undefined) {
          form[k] = k === 'planAttachment' ? this.normalizePlanAttachment(val[k]) : val[k]
        }
      })
      this.form = form
      if (val.parentTagId != null) {
        this.form.parentTagId = Number(val.parentTagId)
      }
      if (val.childTagId != null) {
        this.form.childTagId = Number(val.childTagId)
      }
      this.refreshTagDic()
    },
    echoData () {
      const out = {}
      MAIN_PLAN_FIELDS.forEach(k => {
        if (this.form[k] !== undefined) {
          out[k] = k === 'planAttachment' ? this.normalizePlanAttachment(this.form[k]) : this.form[k]
        }
      })
      return out
    }
  }
}
</script>

<style scoped>
::v-deep .avue-form__menu {
  display: none;
}
.inspection-page {
  display: flex;
  padding: 18px 20px 10px;
  gap: 16px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e6edf6;
}
.left-form {
  flex: 1;
}
::v-deep .avue-form .el-form-item {
  margin-bottom: 20px;
}
::v-deep .avue-form .el-form-item__label {
  color: #334155;
  font-weight: 500;
}
::v-deep .avue-form .el-input__inner {
  height: 34px;
  line-height: 34px;
}
::v-deep .avue-form .el-textarea__inner {
  min-height: 112px !important;
}
</style>
